<ng-container *transloco="let t">
  <div class="entity-selection-step">
    <!-- Back Button -->
    <button class="back-button" (click)="onBack()" type="button">
      <mzic-svg src="assets/icons/arrow-left-disabled.svg" />
    </button>

    <!-- Header -->
    <div class="step-header">
      <h1 class="step-title">{{ t('lang.entity_selection_title_' + contextKeySuffix) }}</h1>
      <p class="step-subtitle">{{ t('lang.entity_selection_subtitle_' + contextKeySuffix) }}</p>
    </div>

    <!-- Search Bar -->
    <div class="search-container" *ngIf="!error()">
      @if (loading()) {
        <div class="search-input-skeleton" aria-hidden="true">
          <span class="search-skeleton-icon"></span>
          <span class="search-skeleton-copy"></span>
        </div>
      } @else {
        <div class="search-input-wrapper">
          <mzic-svg src="assets/icons/mzic-search.svg" class="search-icon" />
          <input
            type="text"
            class="search-input"
            [placeholder]="t('lang.entity_search_placeholder_' + contextKeySuffix)"
            [value]="searchTerm()"
            (input)="onSearchChange($event)" />
          @if (searchTerm()) {
            <button
              class="clear-search-button"
              (click)="clearSearch()"
              type="button">
              <mzic-svg src="assets/icons/mzic-close.svg" />
            </button>
          }
        </div>
      }
    </div>

    <!-- Error State -->
    @if (error()) {
      <div class="error-container">
        <div class="error-icon">
          <mzic-svg src="assets/icons/mzic-close-filled.svg" />
        </div>
        <p class="error-message">{{ error() }}</p>
        <button class="retry-button" (click)="retryLoad()" type="button">
          {{ t('lang.retry') }}
        </button>
      </div>
    }

    <!-- Loading State with Shimmer -->
    @if (loading()) {
      <div class="entity-list-shimmer">
        @for (item of shimmerItems; track item) {
          <div class="shimmer-card">
            <div class="shimmer-icon"></div>
            <div class="shimmer-content">
              <div class="shimmer-title"></div>
              <div class="shimmer-description"></div>
            </div>
          </div>
        }
      </div>
    }

    <!-- Entity List -->
    @if (!loading() && !error()) {
      <div class="entity-list">
        @for (entity of filteredEntities; track entity.id) {
          <div
            class="entity-card"
            [class.selected]="selectedEntity()?.id === entity.id"
            (click)="selectEntity(entity)">
            @if (entity.icon_url) {
              <img
                [src]="entity.icon_url"
                [alt]="entity.display_name"
                class="entity-icon" />
            } @else {
              <div class="entity-icon-placeholder">
                <mzic-svg src="assets/icons/mzic-building.svg" />
              </div>
            }
            <div class="entity-content">
              <h3 class="entity-name">{{ entity.display_name }}</h3>
              @if (entity.description) {
                <p class="entity-description">{{ entity.description }}</p>
              }
            </div>
            @if (selectedEntity()?.id === entity.id) {
              <div class="selected-indicator">
                <mzic-svg src="assets/icons/mzic-check-mark-filled.svg" />
              </div>
            }
          </div>
        } @empty {
          <div class="no-results">
            <mzic-svg
              src="assets/icons/mzic-search.svg"
              class="no-results-icon" />
            <p class="no-results-message">{{ t('lang.no_entities_found_' + contextKeySuffix) }}</p>
          </div>
        }
      </div>
    }

    <!-- Continue Button - Always visible, disabled during loading/error -->
    <div class="action-buttons">
      <button
        class="continue-button"
        [disabled]="loading() || error() || !selectedEntity()"
        (click)="onContinue()"
        type="button">
        {{ t('lang.continue') | uppercase }}
      </button>
    </div>

  </div>
</ng-container>
